export default function (r, e, o) {
  if (!r) throw new Error("You need to provide `widgetName` in your data");
  var t = ["ais-" + r];
  return e && t.push("-" + e), o && t.push("--" + o), t.join("");
}